<template>
  <span>
    <span v-if="mode === 'font-class'" :class="['iconhuice', fontClassName]" :style="fontClassStyle"></span>
    <svg v-else-if="mode === 'svg'" class="icon" :style="svgStyle" aria-hidden="true">
      <use :xlink:href="svgHref" />
    </svg>
  </span>
</template>

<script>
export default {
  name: 'IconHc',
  props: {
    mode: {
      type: String,
      default: 'font-class' // svg font-class
    },
    type: {
      type: String,
      default: 'auto'
    },
    size: {
      type: String,
      default: '16px'
    },
    color: {
      type: String,
      default: 'currentColor'
    }
  },
  computed: {
    svgStyle() {
      return {
        width: this.size,
        height: this.size,
        fill: this.color
      }
    },
    fontClassStyle() {
      return {
        fontSize: this.size,
        color: this.color
      }
    },
    svgHref() {
      if ((this.type).startsWith('icon-')) {
        return `#${this.type}`
      }

      return `#icon-${this.type}`
    },
    fontClassName() {
      if ((this.type).startsWith('icon-')) {
        return `${this.type}`
      }

      return `icon-${this.type}`
    }
  }
}
</script>
